import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class NotificationConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointNotifications() {
    return `${NotificationConfig.endpoint}/bo_notifications`;
  }
  static get endpointSaveNotification() {
    return `${NotificationConfig.endpointNotifications}/save`;
  }
  static get endpointDeleteNotification() {
    return `${NotificationConfig.endpointNotifications}/delete`;
  }
  static get endpointUsersNotified() {
    return `${NotificationConfig.endpointNotifications}/users`;
  }
  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/notification/NotificationConfig.js